export default __webpack_public_path__ + "static/media/rafael_castillo.3a94c04e.png";